module.exports = __webpack_public_path__ + "static/media/ic_merikontti_b.282fceeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_merikontti_b.svg
// module id = 1186
// module chunks = 0